import { render, staticRenderFns } from "./ImgUploadDetail.vue?vue&type=template&id=42d32b66&scoped=true"
import script from "./ImgUploadDetail.vue?vue&type=script&lang=js"
export * from "./ImgUploadDetail.vue?vue&type=script&lang=js"
import style0 from "./ImgUploadDetail.vue?vue&type=style&index=0&id=42d32b66&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d32b66",
  null
  
)

export default component.exports